module.exports = __webpack_public_path__ + "assets/img/11_738_big.bb3fd088.jpg";